import { render, staticRenderFns } from "./parameterSetting.vue?vue&type=template&id=4a940507&scoped=true&"
import script from "./parameterSetting.vue?vue&type=script&lang=js&"
export * from "./parameterSetting.vue?vue&type=script&lang=js&"
import style0 from "./parameterSetting.vue?vue&type=style&index=0&id=4a940507&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a940507",
  null
  
)

export default component.exports